module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_04.a3c340e5.jpg";